import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { useGetBoard } from '../../../../queries';
import { AppBarNavigationItemPortalDestinationId } from '../../../components/AppBar';
import { MultiContainerHeader } from '../../../components/MultiContainerHeader';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../components/Tooltip';
import { SmallGraph } from '../../../components/svgs/graphics/SmallGraphGraphic';
import { DoubleArrowIcon } from '../../../components/svgs/icons/DoubleArrowIcon';
import { BreadcrumbBar } from '../../../components-v2/BreadcrumbBar';
import { ROUTES } from '../../../constants/routes';
import { brandSecondary } from '../../../styles/colors';
import { INavigationItemProps } from '../../MainContainer';
import { OpportunitiesContent } from './OpportunitiesContent';
import { styleSheet } from './styles';

interface IProps extends INavigationItemProps {
	className?: string;
}

export function OpportunitiesBoard({ routeContainerClassName }: IProps) {
	const history = useHistory();
	const match = useRouteMatch<{
		id: string;
	}>();

	const [locationName, setLocationName] = React.useState('Opportunities Board');

	const { id: boardId } = match.params;
	const getBoardQuery = useGetBoard({
		boardId,
	});

	return (
		<div className={`${css(styleSheet.container)} ${routeContainerClassName}`}>
			<MultiContainerHeader
				appBarHeader={
					<BreadcrumbBar
						items={[
							{ label: 'Data Boards', path: ROUTES.dataBoards.home },
							{ label: getBoardQuery.data?.name ?? 'Opportunities Board', path: match.url },
						]}
						banner={
							<TooltipProvider>
								<div className={css(styleSheet.banner)}>
									<Tooltip>
										<TooltipTrigger asChild>
											<a
												href='#'
												className={css(styleSheet.bannerLink)}
												onClick={ev => {
													ev.preventDefault();
													history.push(
														`${ROUTES.dataBoards.opportunitiesAdvancedReporting}?boardId=${encodeURIComponent(boardId)}`
													);
												}}
											>
												<SmallGraph />
												<span className={css(styleSheet.bannerLinkText)}>
													Check our advanced reporting{' '}
													<DoubleArrowIcon fillColor={brandSecondary} style={{ marginLeft: '0.5rem' }} />
												</span>
											</a>
										</TooltipTrigger>
										<TooltipContent>Check our advanced reporting</TooltipContent>
									</Tooltip>
								</div>
							</TooltipProvider>
						}
					/>
				}
				appBarPortalDestinationId={AppBarNavigationItemPortalDestinationId}
				fullscreenHeader={locationName}
			/>

			<OpportunitiesContent setBreadcrumbLocationName={setLocationName} boardId={boardId} />
		</div>
	);
}
